<template>
  <div>
  <ai-tab-nav />
  <div class="ai-dict-page">
    <page-header title="AI 参数配置 - 字典">
      <template #actions>
        <el-button size="small" icon="el-icon-refresh" @click="loadList">刷新</el-button>
        <el-button size="small" icon="el-icon-plus" type="success" @click="openDialog(null)">新增</el-button>
      </template>
      <el-radio-group v-model="activeType" size="small" @change="loadList">
        <el-radio-button label="fee_type">费用类型</el-radio-button>
        <el-radio-button label="doc_type">文档类型</el-radio-button>
      </el-radio-group>
    </page-header>

    <el-alert
      :title="alertTitle"
      type="info"
      :closable="false"
      style="margin-bottom:12px">
      <div slot="default">
        <span v-if="activeType === 'fee_type'">
          管理「费用类型」下拉选项,新增规则和检查项时会从这里取值。
          修改后,所有现有规则中使用此值的项保持不变(按 label 存储)。
        </span>
        <span v-else>
          管理「文档类型」下拉选项,如发票、合作协议、水单等。
          修改后,所有现有规则中使用此值的项保持不变(按 label 存储)。
        </span>
      </div>
    </el-alert>

    <el-table :data="list" v-loading="loading" stripe border size="small" style="width:100%">
      <el-table-column type="index" label="#" width="50" align="center" />
      <el-table-column prop="dictCode" label="代码" width="200" />
      <el-table-column prop="dictLabel" label="显示名" min-width="200" />
      <el-table-column prop="sortOrder" label="排序" width="80" align="center" />
      <el-table-column prop="enabled" label="启用" width="90" align="center">
        <template slot-scope="{ row }">
          <el-switch :value="row.enabled === 1" @change="onToggle(row, $event)" />
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip />
      <el-table-column label="操作" width="160" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="openDialog(row)">编辑</el-button>
          <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="page-footer">
      <span style="color:#909399;font-size:12px">
        共 {{ list.length }} 条 · 启用 {{ enabledCount }} 条
      </span>
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog :title="editForm.id ? '编辑字典项' : '新增字典项'" :visible.sync="dialogVisible" width="500px" append-to-body>
      <el-form :model="editForm" label-width="100px" :rules="rules" ref="editFormRef" size="small">
        <el-form-item label="字典类型">
          <el-tag size="medium">{{ activeType === 'fee_type' ? '费用类型' : '文档类型' }}</el-tag>
        </el-form-item>
        <el-form-item label="代码" prop="dictCode">
          <el-input v-model="editForm.dictCode" placeholder="给程序用,建议与显示名一致" />
          <span style="color:#999;font-size:12px">如「餐费」「发票」</span>
        </el-form-item>
        <el-form-item label="显示名" prop="dictLabel">
          <el-input v-model="editForm.dictLabel" placeholder="用户在下拉框看到的名字" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="editForm.sortOrder" :step="10" :min="0" :max="9999" />
          <span style="color:#999;font-size:12px;margin-left:8px">数字越小越靠前</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="editForm.remark" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="editFormEnabled" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { aiDictApi } from './api.js';
import AiTabNav from './AiTabNav.vue';
import PageHeader from '@/components/PageHeader.vue';

export default {
  name: 'AiDictManage',
  components: { AiTabNav, PageHeader },
  data() {
    return {
      list: [],
      loading: false,
      saving: false,
      activeType: 'fee_type',
      dialogVisible: false,
      editForm: this.emptyForm(),
      rules: {
        dictCode: [{ required: true, message: '代码必填', trigger: 'blur' }],
        dictLabel: [{ required: true, message: '显示名必填', trigger: 'blur' }]
      }
    };
  },
  computed: {
    alertTitle() {
      return this.activeType === 'fee_type' ? '说明 - 费用类型字典' : '说明 - 文档类型字典';
    },
    enabledCount() {
      return this.list.filter(i => i.enabled === 1).length;
    },
    editFormEnabled: {
      get() { return this.editForm.enabled === 1; },
      set(v) { this.editForm.enabled = v ? 1 : 0; }
    }
  },
  created() {
    this.loadList();
  },
  methods: {
    emptyForm() {
      return {
        id: null, dictType: this.activeType || 'fee_type',
        dictCode: '', dictLabel: '', sortOrder: 100, enabled: 1, remark: ''
      };
    },

    async loadList() {
      this.loading = true;
      try {
        const resp = await aiDictApi.list(this.activeType);
        if (resp.code === 200) {
          this.list = resp.data || [];
        } else {
          this.$message.error(resp.msg || '加载失败');
        }
      } catch (e) {
        this.$message.error('网络错误: ' + (e.message || e));
      } finally {
        this.loading = false;
      }
    },

    openDialog(row) {
      if (row) {
        this.editForm = { ...row };
      } else {
        this.editForm = this.emptyForm();
        this.editForm.dictType = this.activeType;
      }
      this.dialogVisible = true;
      this.$nextTick(() => this.$refs.editFormRef && this.$refs.editFormRef.clearValidate());
    },

    handleSave() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return;
        // 确保 dictType 是当前 tab 的
        this.editForm.dictType = this.activeType;
        this.saving = true;
        try {
          const fn = this.editForm.id
            ? aiDictApi.update(this.editForm.id, this.editForm)
            : aiDictApi.create(this.editForm);
          const resp = await fn;
          if (resp.code === 200) {
            this.$message.success('保存成功');
            this.dialogVisible = false;
            this.loadList();
          } else {
            this.$message.error(resp.msg || '保存失败');
          }
        } catch (e) {
          this.$message.error('保存失败: ' + (e.message || e));
        } finally {
          this.saving = false;
        }
      });
    },

    handleDelete(row) {
      this.$confirm(`确认删除「${row.dictLabel}」?注意:此操作不会修改已有规则中使用此值的项`,
        '提示', { type: 'warning' }).then(async () => {
        const resp = await aiDictApi.remove(row.id);
        if (resp.code === 200) {
          this.$message.success('已删除');
          this.loadList();
        } else {
          this.$message.error(resp.msg || '删除失败');
        }
      }).catch(() => {});
    },

    async onToggle(row, value) {
      const resp = await aiDictApi.toggle(row.id, value);
      if (resp.code === 200) {
        row.enabled = value ? 1 : 0;
        this.$message.success(value ? '已启用' : '已禁用');
      } else {
        this.$message.error(resp.msg || '操作失败');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-dict-page {
  padding: 20px;
  background: #fff;
  min-height: 100%;

  /* .page-header 已抽到 PageHeader 组件 */

  .page-footer {
    margin-top: 12px;
    text-align: right;
  }
}
</style>
